import React from "react";
import {
  StyledModalContainer,
  StyledModalContent,
  StyledModalHeader,
  StyledModalBody,
  StyledModalFooter,
  StyledModalSubBody,
} from "./styled";
import Button from "../../components/Button";
import Modal from "@mui/material/Modal";
import { DialogBoxProps } from "../../types/DialogBoxProps";

const DialogBox = ({
  header,
  body,
  subBody,
  onCancel,
  isDelete,
  onSubmit,
  primaryButton,
  secondaryButton,
  width,
  disablePrimary = false,
}: DialogBoxProps) => {
  return (
    <Modal
      open={true}
      onClose={() => {}}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      style={{
        background: "rgba(0, 0, 0, 0.8)",
      }}
      disableRestoreFocus={true}
    >
      <StyledModalContainer style={{ width: width }}>
        <StyledModalContent>
          <StyledModalHeader>{header}</StyledModalHeader>
          <StyledModalBody>{body}</StyledModalBody>
          {subBody ? <StyledModalSubBody>{subBody}</StyledModalSubBody> : <></>}
        </StyledModalContent>
        <StyledModalFooter>
          <Button
            variant="contained"
            size="large"
            color="info"
            onClick={onCancel}
          >
            {secondaryButton}
          </Button>
          <Button
            variant="contained"
            size="large"
            color={isDelete ? "error" : "primary"}
            onClick={onSubmit}
            disabled={disablePrimary}
          >
            {primaryButton}
          </Button>
        </StyledModalFooter>
      </StyledModalContainer>
    </Modal>
  );
};

export default DialogBox;
